import { render, staticRenderFns } from "./AddLocalUserClient.vue?vue&type=template&id=73e4f46e&"
import script from "./AddLocalUserClient.vue?vue&type=script&lang=js&"
export * from "./AddLocalUserClient.vue?vue&type=script&lang=js&"
import style0 from "./AddLocalUserClient.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports